import { render } from "./DesignNature.vue?vue&type=template&id=f16d4eb0&scoped=true"
import script from "./DesignNature.vue?vue&type=script&lang=js"
export * from "./DesignNature.vue?vue&type=script&lang=js"

import "./DesignNature.vue?vue&type=style&index=0&id=f16d4eb0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f16d4eb0"]])

export default __exports__